import getEnabledItems from '@lyearn/core/utils/array/getEnabledItems';
import { QuizPerformanceAttempt } from '@/types/schema';

import { getIsQuizInProgress } from '../../../../utils';
import { QuizDetailsContentFragment } from '../../graphql/fragments/generated/QuizDetailsContent';
import { QuizDetailsPerformanceFragment } from '../../graphql/fragments/generated/QuizDetailsPerformance';
import { getCanRetakeQuiz } from '../../utils/getCanRetakeQuiz';
import { QuizDetailsActions } from './types';

export const getBestScore = (quizPerformance?: QuizDetailsPerformanceFragment) => {
  return quizPerformance?.maxSubmissionDetails?.score || quizPerformance?.score || 0;
};

export const getQuizDetailsActions = (
  content: QuizDetailsContentFragment,
  attemptsHistory: QuizPerformanceAttempt[],
  quizPerformance?: QuizDetailsPerformanceFragment,
) => {
  const isQuizInProgress = getIsQuizInProgress(quizPerformance);

  const showViewResults =
    !isQuizInProgress &&
    quizPerformance?.isSubmitted &&
    (!content.settings?.retakeAllowedCount || content.settings?.retakeAllowedCount === 1);
  const showAttemptsHistory =
    !isQuizInProgress &&
    (content.settings?.retakeAllowedCount || 0) > 1 &&
    attemptsHistory.length >= 1;

  const canRetakeQuiz =
    attemptsHistory.length >= 1 && getCanRetakeQuiz(content, quizPerformance).canRetakeQuiz;

  const actions = [
    {
      id: QuizDetailsActions.StartQuiz,
      labelKey: 'Common:ContentCards.StartQuiz',
      enabled: !attemptsHistory.length && !isQuizInProgress,
    },
    {
      id: QuizDetailsActions.ResumeQuiz,
      labelKey: 'QuizPlayer:ResumeQuiz',
      enabled: isQuizInProgress,
    },
    {
      id: QuizDetailsActions.AttemptsHistory,
      labelKey: 'QuizPlayer:AttemptHistory',
      enabled: showAttemptsHistory,
    },
    {
      id: QuizDetailsActions.ReattemptQuiz,
      labelKey: 'QuizPlayer:ReAttempt',
      enabled: canRetakeQuiz,
    },
    {
      id: QuizDetailsActions.ViewResults,
      labelKey: 'QuizPlayer:ViewResults',
      enabled: showViewResults,
    },
  ];

  return getEnabledItems(actions);
};
